/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactsTimeseriesPoint
 */
export interface ContactsTimeseriesPoint {
    /**
     * 
     * @type {number}
     * @memberof ContactsTimeseriesPoint
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactsTimeseriesPoint
     */
    averageScore?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactsTimeseriesPoint
     */
    contactPerOverallUser?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactsTimeseriesPoint
     */
    contactPerIndividualUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof ContactsTimeseriesPoint
     */
    dateBucket?: Date;
}

/**
 * Check if a given object implements the ContactsTimeseriesPoint interface.
 */
export function instanceOfContactsTimeseriesPoint(value: object): boolean {
    return true;
}

export function ContactsTimeseriesPointFromJSON(json: any): ContactsTimeseriesPoint {
    return ContactsTimeseriesPointFromJSONTyped(json, false);
}

export function ContactsTimeseriesPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsTimeseriesPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'averageScore': json['averageScore'] == null ? undefined : json['averageScore'],
        'contactPerOverallUser': json['contactPerOverallUser'] == null ? undefined : json['contactPerOverallUser'],
        'contactPerIndividualUser': json['contactPerIndividualUser'] == null ? undefined : json['contactPerIndividualUser'],
        'dateBucket': json['dateBucket'] == null ? undefined : (new Date(json['dateBucket'])),
    };
}

export function ContactsTimeseriesPointToJSON(value?: ContactsTimeseriesPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'averageScore': value['averageScore'],
        'contactPerOverallUser': value['contactPerOverallUser'],
        'contactPerIndividualUser': value['contactPerIndividualUser'],
        'dateBucket': value['dateBucket'] == null ? undefined : ((value['dateBucket']).toISOString()),
    };
}

